import { Repository } from "@/repositories/";
export default class BaseService {
  constructor(resource) {  // Constructor
    this.http = Repository;
    this.resource = resource
  }
  
  _(...args){
    this.__args = args
    return this;
  }


  _getResource(){
    let self = this;
    if(this.resource.includes(':')){
      let path = this.resource.split("/")
      path = path.map(uri => {
        return (uri.match(new RegExp(/:\w+/g))) ? self.__args.shift() : uri
      });
      return path.join("/")
    }else{
      return this.resource;
    }
  }

  all(config){
    return this.http.get(`${this._getResource()}`, config);
  }

  create(payload, config){
    return this.http.post(`${this._getResource()}`, payload, config);
  }

  show(id, config){
    return this.http.get(`${this._getResource()}/${id}`, config);
  }

  delete(id, config){
    return this.http.delete(`${this._getResource()}/${id}`, config);
  }

  update(id, payload, config){
    return this.http.patch(`${this._getResource()}/${id}`, payload, config);
  }
}
